export default {
  tabela: {
    codigo: 'Código',
    aliquotaIpi: 'Alíquota IPI (%)',
    descricao: 'Descrição',
  },
  titulo_modal: 'Classificações Fiscais',
};
